import { useMemo } from 'react';

import { getGroupedItems, GroupableItem } from '../itemGroupingHelpers';

export function useGroupedItems<T extends GroupableItem>(items: T[]) {
  return useMemo(() => getGroupedItems<T>(items), [items]);
}
